import React from "react";
import { Controller, useForm } from "react-hook-form";
import { GeneralSettings } from "../../../../core/api/models";
import ErrorMessage from "../../../../components/text/ErrorMessage";
import currencyCodes from "currency-codes";
import { DropdownList } from "react-widgets";
import moment from "moment";
import validator from "validator";

const UpdateForm: React.FunctionComponent<{
  onSubmit: (data: GeneralSettings) => void;
  onCancel: () => void;
  isSubmitting?: boolean;
  data?: GeneralSettings;
  error?: string;
}> = (props) => {
  const { control, handleSubmit, errors } = useForm<GeneralSettings>({
    reValidateMode: "onChange",
    mode: "onSubmit",
  });

  const renderBrandLogoUrl = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3">
          <label className="font-sm text-uppercase">Brand Logo Url<span className="text-danger">*</span></label>
          <Controller
            control={control}
            rules={{
              required: "Brand Logo Url is required",
              validate: {
                validUrl: (value) => validator.isURL(value) || "Invalid URL",
              },
            }}
            name="logoUrl"
            defaultValue={props.data?.logoUrl}
            render={({ onChange, value, name }) => (
              <input
                type="text"
                className="form-control rounded-sm font-weight-semibold"
                placeholder="Brand Logo Url"
                name={name}
                value={value}
                onChange={onChange}
                id="logoUrl"
              />
            )}
          />
          <ErrorMessage>{errors.logoUrl?.message}</ErrorMessage>
        </div>
      </div>
    );
  };

  const renderAlghanimLogoUrl = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3">
          <label className="font-sm text-uppercase">Alghanim Logo Url</label>
          <Controller
            control={control}
            rules={{
              // required: 'Alghanim Logo Url is required',
              validate: {
                validUrl: (value) =>
                  value?.trim()
                    ? validator.isURL(value) || "Invalid URL"
                    : true,
              },
            }}
            name="alghanimLogoUrl"
            defaultValue={props.data?.alghanimLogoUrl}
            render={({ onChange, value, name }) => (
              <input
                type="text"
                className="form-control rounded-sm font-weight-semibold"
                placeholder="Alghanim Logo Url"
                name={name}
                value={value}
                onChange={onChange}
                id="alghanimLogoUrl"
              />
            )}
          />
          <ErrorMessage>{errors.alghanimLogoUrl?.message}</ErrorMessage>
        </div>
      </div>
    );
  };

  const renderFranchiseName = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3">
          <label className="font-sm text-uppercase">Franchisee<span className="text-danger">*</span></label>
          <Controller
            control={control}
            rules={{ required: "Franchisee is required" }}
            name="franchiseName"
            defaultValue={props.data?.franchiseName}
            render={({ onChange, value, name }) => (
              <input
                type="text"
                className="form-control rounded-sm font-weight-semibold"
                placeholder="Franchisee"
                name={name}
                value={value}
                onChange={onChange}
                id="franchiseName"
                disabled
              />
            )}
          />
          <ErrorMessage>{errors.franchiseName?.message}</ErrorMessage>
        </div>
      </div>
    );
  };
  const renderCurrency = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3">
          <label className="font-sm text-uppercase">Currency<span className="text-danger">*</span></label>
          <Controller
            control={control}
            rules={{ required: "Currency is required" }}
            name="currency"
            defaultValue={props.data?.currency}
            render={({ onChange, value, name }) => (
              <DropdownList
                data={currencyCodes.codes().map((code) => {
                  return {
                    label: code,
                    value: code,
                  };
                })}
                id="currency"
                placeholder="Currency"
                name={name}
                value={value}
                onChange={(val) => onChange(val.value)}
                textField="label"
                valueField="value"
                filter="contains"
              />
            )}
          />
          <ErrorMessage>{errors.currency?.message}</ErrorMessage>
        </div>
      </div>
    );
  };

  const renderTimeZone = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3">
          <label className="font-sm text-uppercase">Time Zone<span className="text-danger">*</span></label>
          <Controller
            control={control}
            rules={{ required: "Time Zone is required" }}
            name="timeZone"
            defaultValue={props.data?.timeZone}
            render={({ onChange, value, name }) => (
              <DropdownList
                data={moment.tz.names().map((tz) => {
                  return {
                    label: tz,
                    value: tz,
                  };
                })}
                id="timeZone"
                placeholder="Time Zone"
                name={name}
                value={value}
                onChange={(val) => onChange(val.value)}
                textField="label"
                valueField="value"
                filter="contains"
                disabled
              />
            )}
          />
          <ErrorMessage>{errors.timeZone?.message}</ErrorMessage>
        </div>
      </div>
    );
  };

  const renderButton = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3 text-right pt-3">
          <button
            type="button"
            className="btn btn-outline-dark py-2 font-weight-semibold font-normal px-4 mr-1"
            onClick={props.onCancel}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="btn btn-primary py-2 font-weight-semibold font-normal px-4 "
            disabled={props.isSubmitting}
          >
            Update
          </button>
        </div>
      </div>
    );
  };

  return (
    <form onSubmit={handleSubmit(props.onSubmit)}>
      <div className="p-4">
        <h4 className="mb-3 font-weight-semibold">Update General Settings</h4>
        <div className="row gutter-10">
          {/* {renderFranchiseName()} */}
          {renderCurrency()}
          {renderTimeZone()}
          {renderBrandLogoUrl()}
          {renderAlghanimLogoUrl()}
          <ErrorMessage>{props.error}</ErrorMessage>
          {renderButton()}
        </div>
      </div>
    </form>
  );
};

export default UpdateForm;
